const TableContent = [
  {
    RankNo: "#1",
    RankImg: "Person-12.png",
    RankName: "Stuw dale",
    Unique: "87",
    TotalNFT: "87",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
  {
    RankNo: "#2",
    RankImg: "Person-13.png",
    RankName: "Phoenix Baker",
    Unique: "36",
    TotalNFT: "36",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
  {
    RankNo: "#3",
    RankImg: "Person-14.png",
    RankName: "Lana Steiner",
    Unique: "55",
    TotalNFT: "55",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
  {
    RankNo: "#4",
    RankImg: "Person-15.png",
    RankName: "Demi Wilkinson",
    Unique: "48",
    TotalNFT: "48",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
  {
    RankNo: "#5",
    RankImg: "Person-16.png",
    RankName: "Natali Craig",
    Unique: "33",
    TotalNFT: "33",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
  {
    RankNo: "#6",
    RankImg: "Person-17.png",
    RankName: "Drew Cano",
    Unique: "11",
    TotalNFT: "11",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
  {
    RankNo: "#6",
    RankImg: "Person-18.png",
    RankName: "Andi Lane",
    Unique: "20",
    TotalNFT: "20",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
  {
    RankNo: "#6",
    RankImg: "Person-19.png",
    RankName: "Kate Morrison",
    Unique: "50",
    TotalNFT: "50",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
    TotalSales: "100 Eth",
  },
];
export { TableContent };
